import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "CampaignEditorRow CampaignImportBanner"
}
const _hoisted_2 = { class: "CampaignImportBannerContent" }
const _hoisted_3 = { class: "CampaignImportBannerList" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.details)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "lnr-checkmark-circle CampaignImportBannerIcon" }, null, -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createTextVNode(" Configuration imported from ", -1 /* CACHED */)),
          _createElementVNode("strong", null, _toDisplayString(_ctx.details.sourceCampaignName), 1 /* TEXT */),
          _cache[2] || (_cache[2] = _createTextVNode(". Imported: ", -1 /* CACHED */)),
          _createElementVNode("ul", _hoisted_3, [
            _createElementVNode("li", null, _toDisplayString(_ctx.details.amountLinkedOrganisations) + " organisation(s)", 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString(_ctx.details.amountAttachedEntities) + " entities", 1 /* TEXT */),
            (_ctx.details.hasGeotargetedEntities)
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, "Geotargeting settings"))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("button", {
          class: "CampaignImportBannerCloseButton",
          "aria-label": "Dismiss",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, " × ")
      ]))
    : _createCommentVNode("v-if", true)
}